import React from 'react';
import PropTypes from 'prop-types';

function Reset(props) {
    return (
        <span
            onClick={props.onClick}
            className="catalog-filter-section__action catalog-filter-section__action--reset"
        />
    );
}

Reset.propTypes = {
    onClick: PropTypes.func.isRequired
};

export { Reset };
